import { sum } from "d3-array";
import { isNotDefined, getSourcePathAccessor } from "../utils";

const defaultOptions = {
  windowSize: 10,
  sourcePath: "close",
  daysPerYear: 252,
  standardDeviations: 1,
};

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { windowSize, sourcePath, daysPerYear, standardDeviations } = options;

    const source = getSourcePathAccessor(sourcePath);

    const logReturns = [];
    const histVolValues = [];

    for (let i = 0; i < data.length; i++) {
      if (i === 0) {
        histVolValues.push(undefined);
        continue;
      }

      const current = source(data[i]);
      const previous = source(data[i - 1]);

      if (isNotDefined(current) || isNotDefined(previous) || previous === 0) {
        histVolValues.push(undefined);
        continue;
      }

      // Calculate log return
      const logReturn = Math.log(current / previous);
      logReturns.push(logReturn);

      // Keep only last windowSize values
      if (logReturns.length > windowSize) {
        logReturns.shift();
      }

      // Need at least windowSize values to calculate
      if (logReturns.length < windowSize) {
        histVolValues.push(undefined);
        continue;
      }

      // Calculate mean of log returns
      const mean = sum(logReturns) / windowSize;

      // Calculate variance
      const variance =
        sum(logReturns.map((lr) => Math.pow(lr - mean, 2))) / windowSize;

      // Calculate standard deviation
      const stdDev = Math.sqrt(variance);

      // Calculate annualizing factor
      const annualizingFactor =
        100 * Math.sqrt(daysPerYear) * standardDeviations;

      // Calculate Historical Volatility
      const histVol = stdDev * annualizingFactor;

      histVolValues.push(histVol);
    }

    return histVolValues;
  }

  calculator.undefinedLength = function () {
    return options.windowSize;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
